import React from 'react';
import './PrivacyPolicy.css';
import Footer from './sections/Footer';
import LogoMenu from './sections/Menu';

const PrivacyPolicy = () => {
  return (
    <div className="PrivacyPolicy-page">
        <LogoMenu />
        <div className="PrivacyPolicy-section PrivacyPolicy-text-format">
            <h1>Here4U Privacy Policy</h1>
            <p><strong>Effective Date:</strong> July 20, 2025</p>

            <h2>Introduction</h2>
            <p>This Privacy Policy describes how Here4U (“we,” “our,” or “us”) collects, uses, and protects your information when you visit or interact with our website, located at here4u.care and its subdomains (e.g., survivor.here4u.care).</p>
            <p>We are committed to respecting your privacy and providing a safe, supportive environment — especially given the sensitive nature of the topics our site addresses.</p>
            <p>Please note: Here4U is not a covered entity under HIPAA and does not provide clinical or medical services. While we may help users find relevant resources, we do not collect or process protected health information (PHI).</p>

            <h2>1. Information We Collect</h2>
            <p>We collect only the minimal personal information necessary to respond to user inquiries and improve our platform.</p>
            <p><strong>Personal Information (when submitted voluntarily and with consent):</strong></p>
            <ul>
              <li>First and last name</li>
              <li>Email address</li>
              <li>Phone number (optional)</li>
              <li>Message content from contact forms (which may contain sensitive personal disclosures — we encourage users to only share what they are comfortable providing)</li>
            </ul>
            <p><strong>Non-Personal Information:</strong></p>
            <ul>
              <li>Browser type and version</li>
              <li>Pages visited and time spent on site</li>
              <li>IP address (anonymized or masked where applicable)</li>
              <li>Device type and operating system</li>
              <li>Cookie preferences and consent (if applicable)</li>
            </ul>
            <p>We do not use tracking pixels or behavioral advertising technologies.</p>

            <h2>2. How We Use Your Information</h2>
            <ul>
              <li>To respond to your inquiries or partnership requests</li>
              <li>To improve the functionality, accessibility, and performance of our site</li>
              <li>To anonymize and analyze general usage trends for internal planning</li>
              <li>To inform trauma-informed improvements to the user experience</li>
            </ul>

            <h2>3. Sharing Your Information</h2>
            <p>We do not sell, rent, or trade your personal information.</p>
            <p>We do not share your data with third parties, except:</p>
            <ul>
              <li>With your explicit consent (e.g., when you opt in via checkbox or submit a contact request)</li>
              <li>As required by law (e.g., court orders, legal investigations)</li>
              <li>With trusted service providers who help us operate our site (e.g., web hosting, email delivery)</li>
            </ul>

            <h2>4. Data Retention</h2>
            <p>We retain personal data only as long as necessary to fulfill the purposes described in this policy. Unless required by law, personal data is deleted within 12 months after its original purpose is fulfilled or upon verified request for deletion. You may request deletion of your data at any time.</p>

            <h2>5. Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul>
              <li>Access the personal data we hold about you</li>
              <li>Request corrections to inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p>Additional rights may apply if you reside in jurisdictions such as the European Union (GDPR), California (CCPA), or similar regions. To exercise any of these rights, email us at <a href="mailto:hello@here4u.care">hello@here4u.care</a>. We aim to respond to all verified requests within 30 days.</p>

            <h2>6. Security</h2>
            <p>We take reasonable administrative and technical steps to protect your information.</p>
            <ul>
              <li>End-to-end encryption of form submissions (e.g., TLS 1.2 or higher)</li>
              <li>Encrypted storage (e.g., AES-256 where applicable)</li>
              <li>Limited access to data by trained, authorized personnel only</li>
              <li>Routine security audits and updates to minimize vulnerabilities</li>
            </ul>

            <h2>7. Children’s Privacy</h2>
            <p>This site is not intended for use by children under 18. We do not knowingly collect personal data from anyone under this age. If you are under 18 and seeking support, we encourage you to speak with a trusted adult or use professional child-appropriate resources.</p>

            <h2>8. Cookies and Analytics Consent</h2>
            <p>We may use cookies to enhance your experience, analyze traffic, and understand usage patterns on our site. These cookies do not contain personally identifiable information.</p>
            <p><strong>Cookie types include:</strong></p>
            <ul>
              <li>Essential cookies (required for core functionality)</li>
              <li>Performance and analytics cookies</li>
            </ul>
            <p>Our analytics tools (such as Google Analytics) are configured to anonymize IP addresses where possible and avoid cross-site tracking. You can also opt out of Google Analytics by visiting this page: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">https://tools.google.com/dlpage/gaoptout</a>.</p>

            <h2>9. Third-Party Services</h2>
            <p>We may use basic website tools or analytics platforms (e.g., Google Analytics) to better understand how users navigate the site.</p>
            <p>These services may set cookies; you can disable them through your browser settings or via our cookie banner.</p>
            <p>For more information, please consult the respective privacy policies of these providers:</p>
            <ul>
              <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a></li>
            </ul>

            <h2>10. Updates to This Policy</h2>
            <p>We may update this policy from time to time. Changes will be posted on this page with a revised effective date. For material changes, we will provide a notice via the homepage and, where appropriate, contact you directly.</p>

            <h2>11. Contact Us</h2>
            <p>If you have questions about this privacy policy or our practices, please contact us at:</p>
            <p>Email: <a href="mailto:hello@here4u.care">hello@here4u.care</a></p>

            <p><strong>Thank you for trusting Here4U.</strong><br />
            We are committed to your privacy, safety, and empowerment.</p>
        </div>
        <Footer />
    </div>
  );
};

export default PrivacyPolicy;